import TfMaterial from '@/micro-app/tf-material';
import pandoraRouteConfig from './pandora/route-config';
import Pandora from './pandora';
import autoMaterialsRouteConfig from './auto-materials/route-config';
import AutoMaterials from './auto-materials';
// import Pandora from './pandora'
// import Material from './material'

const routeConfig = [
  {
    menuId: 40,
    title: '商品组',
    path: '/material/goods',
    getLink({ path }) {
      return `${path}#/product`;
    },
    component: TfMaterial,
  },
  {
    menuId: 41,
    title: '广告组',
    // title: '素材中心',
    path: '/material/adv',
    getLink({ path }) {
      return `${path}#/advert`;
    },
    component: TfMaterial,
  },
  // {
  //   title: '主站',
  //   path: '/launch',
  //   component: Launch,
  //   hideInNav: true
  // },
  {
    menuId: 42,
    title: '潘多拉',
    path: '/pandora',
    component: Pandora,
    menus: pandoraRouteConfig,
  },
  {
    menuId: 43,
    title: '自动化素材',
    path: '/auto',
    component: AutoMaterials,
    menus: autoMaterialsRouteConfig,
  },
];

export default routeConfig;
